<template>
  <!-- 综合查询 -->
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left" style="text-align:right;">
      </div>
    </div>
    <mytable
      :maxHeight="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="false"
      :isselection="false"
      :isShowMoreOperate="false"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
    ></mytable>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageStart"
      :page-size="pageTotal"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageCount"
    >
    </el-pagination>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  props: {
    dispatchId: {},
    isSee: {},
  },
  mixins: [tableListNew ],
  components: {
    queryCondition,
    sorttable,
    paging,
    queryBtns,
    mytable,
    myDialog,
  },
  data() {
    return {
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "详情", //按钮名称
          methods: "detail", //当前页面的方法
          param: 1, //自定义参数标记
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      //需要单独点击的列字段名数组
      fieldList: ["dispatchNumber"],
      Operatewidth: "220px", //操作列的列宽
      //=======================导出相关 结束 =======================

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "CarTimingLogModeList", //  页面标识
      reportFiledsNumber: "admin_dispatch_log_mode_list", // 动态 条件、表头
      activeName: "first",
      selectedId: "",
      selectedNumber: "",
      showTraceDialog: false,
    };
  },
  async mounted() {
    if (this.dispatchId) {
      this.getData({
        dispatchId: this.dispatchId,
      });
    }
  },
  watch: {
    dispatchId: {
      handler(val) {
        if (!val) {
          return;
        }
        this.getDetail()
      },
    },
  },
  methods: {
    async getDetail() {
      if (this.dispatchId) {
        this.getData({
          dispatchId:this.dispatchId
        })
      }
    },
  },
};
</script>


<style scoped lang="less">
.container {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
</style>
